module.exports = __webpack_public_path__ + "img/congratulations-bg.8f708969.png";